import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "modal",
  tabindex: "-1",
  id: "pryal_cliente_cadastro"
}
const _hoisted_2 = { class: "\n        modal-dialog\n        modal-dialog-centered\n        modal-dialog-scrollable\n        modal-fullscreen-sm-down\n      " }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title d-flex flex-column align-items-start" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-2x" })
], -1)
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = { class: "form-floating mb-3" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { for: "formNome" }, "Nome do Cliente", -1)
const _hoisted_12 = { class: "invalid-feedback" }
const _hoisted_13 = { class: "form-floating mb-3" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { for: "formCpf" }, "CPF", -1)
const _hoisted_15 = { class: "invalid-feedback" }
const _hoisted_16 = { class: "form-floating mb-3" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", { for: "formEmail" }, "Email", -1)
const _hoisted_18 = { class: "invalid-feedback" }
const _hoisted_19 = { class: "form-floating mb-3" }
const _hoisted_20 = /*#__PURE__*/_createVNode("label", { for: "formDtnascimento" }, "Data de Nascimento", -1)
const _hoisted_21 = { class: "invalid-feedback" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createVNode("hr", { class: "mt-2 mb-2" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("h3", null, "Veículos", -1)
const _hoisted_25 = { className: "font-size-sm" }
const _hoisted_26 = /*#__PURE__*/_createVNode("span", null, "Editar", -1)
const _hoisted_27 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_28 = {
  key: 0,
  type: "button",
  class: "btn btn-sm btn-info",
  "data-bs-toggle": "modal",
  "data-bs-target": "#pryal_veiculo_cadastro"
}
const _hoisted_29 = { class: "modal-footer" }
const _hoisted_30 = {
  type: "button",
  ref: "closeModal",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")
  const _component_Form = _resolveComponent("Form")
  const _component_VeiculoCadastro = _resolveComponent("VeiculoCadastro")
  const _directive_mask = _resolveDirective("mask")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("h5", _hoisted_5, [
              (_ctx.isCadastroNovo)
                ? (_openBlock(), _createBlock("span", _hoisted_6, " Cadastro de novo cliente "))
                : (_openBlock(), _createBlock("span", _hoisted_7, "Atualizar cadastro de " + _toDisplayString(_ctx.cliente.nome), 1)),
              _createVNode("button", {
                class: "btn btn-sm btn-link p-0",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.excluir && _ctx.excluir(...args)))
              }, " Excluir ")
            ]),
            _hoisted_8
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_Form, {
              name: "formCliente",
              id: "formCliente",
              class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
              ref: "form",
              onSubmit: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isCadastroNovo === true ? _ctx.cadastrar() : _ctx.atualizar())),
              "validation-schema": _ctx.validacoes
            }, {
              default: _withCtx(({ errors }) => [
                _createVNode("div", _hoisted_10, [
                  _createVNode(_component_Field, {
                    modelValue: _ctx.cadastro.nome,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.cadastro.nome = $event)),
                    type: "text",
                    class: ["form-control", { 'is-invalid': errors.formNome }],
                    name: "formNome",
                    placeholder: "Nome do Cliente"
                  }, null, 8, ["modelValue", "class"]),
                  _hoisted_11,
                  _createVNode("div", _hoisted_12, _toDisplayString(errors.formNome), 1)
                ]),
                _createVNode("div", _hoisted_13, [
                  _withDirectives(_createVNode(_component_Field, {
                    modelValue: _ctx.cadastro.cpf,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.cadastro.cpf = $event)),
                    type: "text",
                    class: ["form-control", { 'is-invalid': errors.formCpf }],
                    name: "formCpf",
                    placeholder: "CPF"
                  }, null, 8, ["modelValue", "class"]), [
                    [_directive_mask, '###.###.###-##']
                  ]),
                  _hoisted_14,
                  _createVNode("div", _hoisted_15, _toDisplayString(errors.formCpf), 1)
                ]),
                _createVNode("div", _hoisted_16, [
                  _createVNode(_component_Field, {
                    modelValue: _ctx.cadastro.email,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.cadastro.email = $event)),
                    type: "email",
                    class: [{ 'is-invalid': errors.formEmail }, "form-control"],
                    id: "formEmail",
                    name: "formEmail",
                    placeholder: "Email"
                  }, null, 8, ["modelValue", "class"]),
                  _hoisted_17,
                  _createVNode("div", _hoisted_18, _toDisplayString(errors.formEmail), 1)
                ]),
                _createVNode("div", _hoisted_19, [
                  _createVNode(_component_Field, {
                    modelValue: _ctx.cadastro.dataDeNascimento,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.cadastro.dataDeNascimento = $event)),
                    type: "date",
                    class: [{ 'is-invalid': errors.formDtnascimento }, "form-control"],
                    name: "formDtnascimento",
                    placeholder: "Data de Nascimento"
                  }, null, 8, ["modelValue", "class"]),
                  _hoisted_20,
                  _createVNode("div", _hoisted_21, _toDisplayString(errors.formDtnascimento), 1)
                ]),
                (_ctx.cadastro.veiculos && _ctx.cadastro.veiculos.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_22, [
                      _hoisted_23,
                      _hoisted_24,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cadastro.veiculos, (veiculo) => {
                        return (_openBlock(), _createBlock("span", {
                          key: veiculo.id,
                          className: "d-flex align-items-center justify-content-between text-muted mb-3"
                        }, [
                          _createVNode("span", _hoisted_25, _toDisplayString(veiculo.marca) + " " + _toDisplayString(veiculo.modelo) + " | Placa " + _toDisplayString(veiculo.placa), 1),
                          _createVNode("a", {
                            href: "#pryal_veiculo_cadastro",
                            onClick: ($event: any) => (_ctx.setVeiculo(veiculo)),
                            "data-bs-toggle": "modal"
                          }, [
                            _hoisted_26
                          ], 8, ["onClick"])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_27, [
                  (_ctx.cadastro.id != null)
                    ? (_openBlock(), _createBlock("button", _hoisted_28, " Cadastrar veículo "))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["validation-schema"])
          ]),
          _createVNode("div", _hoisted_29, [
            _createVNode("button", _hoisted_30, " Fechar ", 512),
            _createVNode("input", {
              type: "submit",
              class: "btn btn-primary",
              form: "formCliente",
              value: _ctx.isCadastroNovo === true ? 'Cadastrar' : 'Atualizar'
            }, null, 8, ["value"])
          ])
        ])
      ])
    ], 512),
    _createVNode(_component_VeiculoCadastro, {
      veiculo: _ctx.veiculo,
      clienteId: _ctx.cadastro.id
    }, null, 8, ["veiculo", "clienteId"])
  ], 64))
}